package ir.yusefpasha.models

import ir.yusefpasha.util.Res

enum class Achievement(
    val icon: String, val number: Int, val description: String
) {
    Completed(
        icon = Res.Icon.COMPLETED, number = 14, description = "Completed Projects"
    ),

    Active(
        icon = Res.Icon.ACTIVE, number = 3, description = "Active Projects"
    ),

    Satisfied(
        icon = Res.Icon.SATISFIED, number = 2, description = "Satisfied Client"
    ),

    Team(
        icon = Res.Icon.TEAM, number = 4, description = "Team Member"
    )
}